import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Typography,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import { toast } from 'react-toastify';
import CustomButton from '../../component/ui/FormFields/Button';

const DocumentViewer = ({ fileUrl }) => {
  const [proofFileUrl, setProofFileUrl] = useState(null);
  const [proofFileName, setProofFileName] = useState(null);
  const [openDocumentPreview, setOpenDocumentPreview] = useState(false);
  console.log('profo', proofFileName);
  useEffect(() => {
    if (fileUrl) {
      setProofFileUrl(fileUrl);
      setProofFileName(fileUrl.split('/').pop()); // Extract filename
    }
  }, [fileUrl]);

  const handleOpenDocumentPreview = () => {
    if (!proofFileUrl) {
      toast.error('No image available for preview', {
        position: 'top-center',
        autoClose: 3000,
      });
      return;
    }
    setOpenDocumentPreview(true);
  };

  const handleCloseDocumentPreview = () => setOpenDocumentPreview(false);

  const handleDownloadDocument = () => {
    if (!proofFileUrl) {
      toast.error('No image available to download', {
        position: 'top-center',
        autoClose: 3000,
      });
      return;
    }

    const link = document.createElement('a');
    link.href = proofFileUrl;
    link.download = proofFileName || 'downloaded_image.jpg'; // Set a default name if undefined
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Grid item xs={12} sm={6}>
      <Typography variant='subtitle1' className='role-table-fonts'>
        Proof Document
      </Typography>
      <Box
        className='proof-document-head'
        display='flex'
        alignItems='center'
        gap={2}
      >
        <Box display='flex' gap={2}>
          <CustomButton
            variant='contained'
            className='orange-button'
            startIcon={<VisibilityIcon />}
            onClick={handleOpenDocumentPreview}
            text='Preview'
          />
          <CustomButton
            variant='contained'
            className='grey-button'
            startIcon={<DownloadIcon />}
            onClick={handleDownloadDocument}
            text='Download'
          />
        </Box>
      </Box>
      <Dialog
        open={openDocumentPreview}
        onClose={handleCloseDocumentPreview}
        maxWidth='md'
        fullWidth
      >
        <DialogTitle>
          Image Preview
          <IconButton
            aria-label='close'
            onClick={handleCloseDocumentPreview}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {proofFileUrl && (
            <img
              src={proofFileUrl}
              alt='Proof Document'
              style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default DocumentViewer;
